import { Position } from 'src/types/position';

export const comparePositions = <TData extends Position>(
  a: TData,
  b: TData,
): number => a.position - b.position;

export const sortByPosition = <TData extends Position>(
  list: TData[],
): TData[] => list?.sort(comparePositions);
